export class Tier {
  name: string = "";
  entryRequirement: EntryRequirement = new EntryRequirement();
}

export class EntryRequirement {
  rank: string = "Bronze";
  tier: number = 0;
}